<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-11-03 13:43:17
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-19 18:00:28
-->
<template>
  <!-- hidden-sm-and-down  -->
  <v-breadcrumbs class="pa-0"
                 :items="levelList"
                 divider=">">
    <template v-slot:item="props">
      <!-- <v-breadcrumbs-item :to="props.item.path">
        {{ INT(generateTitle(props.item.meta.title)) }}
      </v-breadcrumbs-item> -->
      <span @click.prevent="handleLink(props.item)"
            :class="props.item.path != $route.fullPath ? 'active' : ''"
            class="f5">
        {{ generateTitle(props.item.meta.title) }}
      </span>
    </template>
  </v-breadcrumbs>
</template>

<script>
const pathToRegexp = require('path')

export default {
  name: 'AppBreadcrumbs',
  data: () => ({
    levelList: null,
  }),
  watch: {
    $route () {
      this.getBreadcrumb()
    },
  },
  created () {
    this.getBreadcrumb()
  },
  computed: {},
  methods: {
    generateTitle (title) {
      // const hasKey = this.$te(`${title}`);
      // const hasKey = this.$te(`${title}`);
      // if (hasKey) {
      //   const translatedTitle = this.$t(`${title}`);
      //   return translatedTitle;
      // }
      let pageTitle = ''
      if (Array.isArray(title)) {
        pageTitle = this.INT(title)
      } else {
        pageTitle = this.$t(title)
      }
      return pageTitle
    },
    getBreadcrumb () {
      let matched = this.$route.matched.filter((item) => item.name)
      // const first = matched[0];
      // if (first && first.name.trim().toLocaleLowerCase() !== 'dashboard') {
      //   matched = [{ path: '/dashboard', meta: { title: 'route.dashboard' } }].concat(matched);
      // }

      this.levelList = matched.filter(
        (item) => item.meta && item.meta.title && item.meta.breadcrumb !== false
      )
      // console.log(this.levelList)
    },
    pathCompile (path) {
      const { params } = this.$route
      const toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink (item) {
      // console.log(item)
      // console.log(this.pathCompile(path))
      // return
      const { redirect, path } = item
      if (redirect) {
        this.$router.push(redirect)
        return
      }
      if (path != this.$route.fullPath) {
        this.$router.push(path)
      }
      // this.$router.push(this.pathCompile(path))
    },
  },
}
</script>
<style scoped>
.hidden-sm-and-down {
  padding-left: 0;
  font-size: 13px;
}
/deep/ .v-breadcrumbs__divider {
  color: rgba(0, 0, 0, 0.38) !important;
}
.f5 {
  /* font-family:var(--body-font-family);
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.38); */
  color: rgba(0, 0, 0, 0.5);
}
.active {
  color: var(--main-color) !important;
  cursor: pointer;
}
</style>
